"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const events = require("../../../../constants/constants/events.js");
const isBrowser = () => {
  return typeof window !== "undefined" && typeof window.document !== "undefined";
};
const isLocalStorageChanged = (evt) => {
  return !!evt && typeof evt === "object" && "type" in evt && evt.type === events.LOCAL_STORAGE_CHANGE_EVENT;
};
const isFunction = (value) => typeof value === "function";
const tryParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
function useEffectEvent(callback) {
  const ref = React.useRef(callback);
  ref.current = callback;
  return React.useCallback((...args) => {
    const f = ref.current;
    return f(...args);
  }, []);
}
exports.isBrowser = isBrowser;
exports.isFunction = isFunction;
exports.isLocalStorageChanged = isLocalStorageChanged;
exports.tryParse = tryParse;
exports.useEffectEvent = useEffectEvent;
//# sourceMappingURL=utils.js.map
